/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2022. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatCamelCase' })
@Injectable({
  providedIn: 'root',
})
export class FormatCamelCasePipe implements PipeTransform {
  // https://stackoverflow.com/questions/4149276/how-to-convert-camelcase-to-camel-case
  transform(value: string): any {
    return value.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase());
  }
}
